<template>
  <layout :lead="leadInfo" :rooftop="rooftopInfo" :welcome-message="welcomeMessage">
    <section class="search-hub-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6 pl-lg-0">
            <ul class="search-hub-list">
              <li class="search-hub-information" v-if="bank">
                <figure v-if="bank.logo_url">
                  <img :src="bank.logo_url" :alt="bank.name" />
                </figure>
                <h4>{{ bank.name }}</h4>

                <div class="contact-row" v-if="bank.phone">
                  <div class="icon-container">
                    <img src="/img/icons/phone.svg" />
                  </div>
                  <base-telephone :phone-number="bank.phone" />
                </div>

                <div class="contact-row" v-if="bank.email">
                  <div class="icon-container">
                    <img src="/img/icons/mail.svg" />
                  </div>
                  <base-email :address="bank.email">
                    {{ bank.email }}
                  </base-email>
                </div>

                <div class="contact-row" v-if="bank.address">
                  <div class="icon-container">
                    <img src="/img/icons/location.svg" />
                  </div>
                  <span>{{ bank.address }}</span>
                </div>

                <div class="contact-row" v-if="bank.website">
                  <div class="icon-container">
                    <img src="/img/icons/web.svg" />
                  </div>
                  <a :href="bank.website">{{ bank.website }}</a>
                </div>
                <a
                  class="btn btn-secondary contact-btn mt-2"
                  :href="`data:text/x-vcard;charset=utf-8,${bankContactCard}`"
                  :download="vCardFilename"
                >
                  <svg
                    stroke="white"
                    fill="white"
                    stroke-width="0"
                    viewBox="0 0 24 24"
                    height="1.5rem"
                    width="1.5rem"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
                    />
                  </svg>
                  Download Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import * as VCard from 'vcards-js';
import Layout from '@/layouts/default';
import BaseEmail from '@/components/base-email';
import BaseTelephone from '@/components/base-telephone';
import useActionMessage from '@/composable/useActionMessage';
import { PAGE_TITLES } from '@/constants';
import { getBank } from '@/services/SearchHubService';
import { reactive, toRefs } from '@vue/composition-api';
import { useRoute } from '@/composable/wrappers';

export default {
  name: 'SearchHub',
  metaInfo: {
    title: PAGE_TITLES['search-hub'],
  },
  components: {
    Layout,
    BaseEmail,
    BaseTelephone,
  },
  setup() {
    const { setData } = useActionMessage();

    const route = useRoute();
    const bankID = route.value.query.bank_id;
    getBank(bankID)
      .then(({ data }) => {
        state.bank = data;
        setData(state.bank);
      })
      .catch(() => {
        state.bank = null;
      });

    const state = reactive({
      bank: null,
    });

    return {
      ...toRefs(state),
    };
  },
  data() {
    return {
      welcomeMessage: 'Here is the contact information you need. Go ahead and give them a call.',
    };
  },
  computed: {
    ...mapState(['leadInfo', 'rooftopInfo', 'contents']),
    bankContactCard() {
      let bankVCard = VCard();
      bankVCard = {
        ...bankVCard,
        firstName: this.bank.name,
        lastName: this.bank.lastname,
        email: this.bank.email,
        cellPhone: this.bank.phone,
        url: this.bank.website,
        label: 'Work Address',
        street: this.bank.address_1,
        city: this.bank.city,
        stateProvince: this.bank.state,
        postalCode: this.bank.zip_code,
        countryRegion: this.bank.country_code,
        version: '3.0',
      };
      return encodeURIComponent(bankVCard.getFormattedString());
    },
    vCardFilename() {
      return `${this.bank.name}.vcf`;
    },
  },
};
</script>

<style lang="scss">
$icon-size: 30px;
.contact-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  .icon-container {
    height: $icon-size;
    width: $icon-size;
    background: #0088db;
    margin-right: 0.5rem;
    position: relative;
    border-radius: 100%;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 20px;
      width: 20px;
    }
  }
}
.contact-btn {
  color: #fff !important;
}
</style>
